/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Domain_PartyInputs */

const en_search_domain_party = /** @type {(inputs: Search_Domain_PartyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the directory, users and roles`)
};

/**
* | output |
* | --- |
* | "the directory, users and roles" |
*
* @param {Search_Domain_PartyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const search_domain_party = /** @type {((inputs?: Search_Domain_PartyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Domain_PartyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_search_domain_party(inputs)
});